import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const LicenseContext = createContext(null);

export function LicenseProvider({ children }) {
  const [activated, setActivated] = useState(null); // null = unknown, true/false = checked
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    setChecking(true);
    try {
      const r = await api.get('/license/status');
      setActivated(!!r.data.activated);
    } catch (_) {
      setActivated(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <LicenseContext.Provider value={{ activated, checking, refresh }}>
      {children}
    </LicenseContext.Provider>
  );
}

export function useLicense() {
  const ctx = useContext(LicenseContext);
  if (!ctx) throw new Error('useLicense must be used inside LicenseProvider');
  return ctx;
}
